module.exports = __webpack_public_path__ + "assets/stockings.png?v=f41f9729f95fa56129faeb69200f0c8c";